import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import ComputedPriceField from 'components/show/ComputedPriceField';
import DateTextField from 'components/show/DateFields/DateTextField';
import DownloadPDF from 'components/button/DownloadPDF';
import FullNameTextField from 'components/show/FullNameTextField';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import InvoiceStatus from './InvoiceStatus';
import ListButton from 'components/button/ListButton';
import Section from 'components/ui/general/Section';
import ShowButton from 'components/button/ShowButton';
import StatusTextField from 'components/show/StatusTextField';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import authHelper from 'helpers/auth';
import dateUtils from 'helpers/dateUtils';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { downloadInvoice } from 'http/requests/invoicesRequests';
import { downloadInvoiceFailure } from 'store/actions/invoices/invoiceActions';

const InvoiceShow = (props) => {
    const {
        data,
        id,
        translate,
        user,
    } = props;

    const invoiceLabel = user ?
        `${ utils.fullName(user.first_name, user.last_name) } (${ dateUtils.localeDate(dateUtils.stringToDate(data.invoiced_at), { month: 'long', year: 'numeric' }) })`.trim()
        : dateUtils.localeDate(dateUtils.stringToDate(data.invoiced_at), { month: 'long', year: 'numeric' });

    const isAdmin = authHelper.isAdmin();

    const breadcrumbs = [
        {
            label: translate('resources.invoices.title'),
            link: '/invoices',
        },
        {
            label: invoiceLabel,
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ `${ translate('resources.invoices.show.title') }: ${ invoiceLabel }` } />

                <Actions>
                    { isAdmin && (
                        <DownloadPDF
                            failureAction={ downloadInvoiceFailure }
                            fileName={ `invoice_${ id }.pdf` }
                            id={ id }
                            request={ downloadInvoice }
                            title={ translate('resources.invoices.download') }
                        />
                    ) }

                    <ListButton
                        url='/invoices'
                    />
                </Actions>
            </Header>

            <Section>
                <Column
                    title={ translate('resources.invoices.show.details') }
                >
                    <InnerColumn>
                        <DateTextField
                            label='resources.invoices.fields.invoiced_at'
                            value={ data.invoiced_at }
                        />

                        <ComputedPriceField
                            label='resources.invoices.fields.amount'
                            currency={ data.currency }
                            value={ data.amount }
                        />
                    </InnerColumn>
                    <InnerColumn>
                        <StatusTextField
                            component={ InvoiceStatus }
                            label='resources.invoices.fields.status'
                            record={ data }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <Column
                    title={ translate('resources.users.name') }
                    actions={ user ? <ShowButton url={ `/users/${ data.user_id }/show` } /> : null }
                >
                    {user ? (
                        <InnerColumn>
                            <FullNameTextField
                                data={ user }
                                label='resources.users.fields.name'
                            />

                            <TextField
                                label='resources.users.fields.email'
                                value={ user.email }
                            />

                            <TextField
                                label='resources.users.fields.phonenumber'
                                value={ user.phone }
                            />
                        </InnerColumn>
                    ) : (
                        <InnerColumn>
                            <TextField value={ translate('resources.users.not_found') } />
                        </InnerColumn>
                    )}
                </Column>
            </Section>
        </div>
    );
};

InvoiceShow.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    translate: PropTypes.func,
    user: PropTypes.shape({
        email: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        phone: PropTypes.string,
    }),
};

export default translate(InvoiceShow);


// WEBPACK FOOTER //
// ./src/pages/invoices/show/InvoiceShow.js